(() => {
  const dialog = document.getElementById('rfs-holiday-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'rfs-holiday-2026-notice-seen';
  const force = new URLSearchParams(location.search).get('holiday_popup') === '1';
  if (!force && Date.now() >= Date.parse('2026-12-26T00:00:00-08:00')) return;
  const seen = () => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
  const remember = () => { try { sessionStorage.setItem(key, '1'); } catch {} };
  const dismiss = () => { remember(); dialog.close(); };
  dialog.querySelectorAll('[data-rfs-holiday-close]').forEach(button => button.addEventListener('click', dismiss));
  dialog.querySelector('[data-rfs-holiday-link]').addEventListener('click', remember);
  dialog.addEventListener('cancel', remember);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss();
  });
  const hasOtherOverlay = () => Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]:not([aria-hidden="true"]), .klaviyo-form[role="dialog"]')).some(element => element !== dialog && !dialog.contains(element) && element.getClientRects().length && element.getBoundingClientRect().right > 0 && element.getBoundingClientRect().left < innerWidth && element.getBoundingClientRect().bottom > 0 && element.getBoundingClientRect().top < innerHeight && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).opacity !== '0');
  let attempts = 0;
  const show = () => {
    if (!force && seen()) return;
    if (hasOtherOverlay()) { if (++attempts < 60) window.setTimeout(show, 1000); return; }
    try { dialog.showModal(); dialog.focus({ preventScroll: true }); remember(); } catch {}
  };
  if (document.readyState === 'complete') window.setTimeout(show, 3000);
  else window.addEventListener('load', () => window.setTimeout(show, 3000), { once: true });
})();
